import React, { Component } from 'react';
import Formulario from './DescuentoFijoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";
const valEmp = __CONFIG__.empresa;

class DescuentoFijo extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, leer, listarColaborador,
            listarTiposDesc } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }

        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        if (valEmp === 'fage'){
            getModulo(modulo[6], modulo[5])
        }else{
            getModulo(modulo[5],modulo[4]);
        }
        listarColaborador();
        listarTiposDesc();
    }

    render(){
        const { loader, modulo, 
            emp, registroDescuento,
            lectura, modificarDescuento, tipos } = this.props;
        const { crear } = this.state;
        
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    modulo = {modulo}
                    crear = {crear}
                    emp = {emp}
                    registroDescuento = {registroDescuento}
                    modificarDescuento = {modificarDescuento}
                    lectura = {lectura}
                    tipos = {tipos}
                />
            </LoadMask>
        );
    }
}

export default DescuentoFijo;
